import classnames from "classnames";
import ControlButton from "components/ControlButton";
import React from "react";
import PropTypes from "prop-types";

export default function VolumeControl(props) {
  const volumeIconClass = classnames({
    "icon-Volume1": !props.muted,
    "icon-Volume2": props.muted,
  });

  const classNameModifiers = ["icon", "volume-button"];
  if (props.border) {
    classNameModifiers.push("light");
  }

  return (
    <ControlButton
      ariaLabel="Toggle Mute"
      border={props.border}
      classNameModifiers={classNameModifiers}
      key="volume-button"
      onClick={props.onToggleMute}
    >
      <span className={volumeIconClass} />
    </ControlButton>
  );
}

VolumeControl.propTypes = {
  border: PropTypes.bool,
  muted: PropTypes.bool.isRequired,
  onToggleMute: PropTypes.func,
};
